import React from 'react';

import { static_privacy_path, static_terms_path } from '@routes';

import IconLock from '../../Images/Rebranding/IconLock';

export const CANCELLATION_INSTRUCTIONS_URL =
  'https://theinformation.zendesk.com/hc/en-us/articles/218193188-Cancel-subscription';

const Disclosure = () => (
  <div className="mt-24 text-center font-suisse-screen text-disclosure-sm text-grayscale-gray">
    <IconLock className="w-12 text-black" />
    <div className="my-8">We value your privacy and security</div>
    <div>
      By clicking “Subscribe” you agree to our{' '}
      <a
        className="font-medium text-inherit underline"
        target="_blank"
        rel="noreferrer"
        href={static_terms_path()}
      >
        Terms of Service
      </a>{' '}
      and acknowledge our{' '}
      <a
        className="font-medium text-inherit underline"
        target="_blank"
        rel="noreferrer"
        href={static_privacy_path()}
      >
        Privacy Policy
      </a>
      . Subscriptions renew automatically until you{' '}
      <a
        className="font-medium text-inherit underline"
        target="_blank"
        rel="noreferrer"
        href={CANCELLATION_INSTRUCTIONS_URL}
      >
        cancel online.
      </a>
    </div>
    <div className="text-xs mt-24 text-gray-500">
      This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
    </div>
  </div>
);

export default Disclosure;
